import { render, staticRenderFns } from "./screenModificacionPedido.vue?vue&type=template&id=b9146b72&scoped=true"
import script from "./screenModificacionPedido.vue?vue&type=script&lang=js"
export * from "./screenModificacionPedido.vue?vue&type=script&lang=js"
import style0 from "./screenModificacionPedido.vue?vue&type=style&index=0&id=b9146b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9146b72",
  null
  
)

export default component.exports